import {JsonApiResponse} from '@/types/JsonApiResponse.interface';

export const JsonApiResponseSchema: JsonApiResponse<[]> = {
    data: [],
    meta: {
        currentPage: 1,
        total: 0,
        perPage: 10,
    },
};
